import { render, staticRenderFns } from "./NotificationSettingsModal.vue?vue&type=template&id=ce9128ba&scoped=true"
import script from "./NotificationSettingsModal.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingsModal.vue?vue&type=style&index=0&id=ce9128ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9128ba",
  null
  
)

export default component.exports